<template>
  <standard-container :title="$t('status.players')">
    <template v-slot:title>
      <v-btn
        :title="$t('navbar.status')"
        icon
        @click="goToStatus"
      >
        <v-icon>mdi-account-convert-outline</v-icon>
      </v-btn>
      <v-text-field
        v-if="showSearch"
        v-model="search"
        :label="$t('project.search')"
        single-line
        hide-details
        clearable
      />
      <v-btn
        icon
        @click="showSearch = !showSearch"
      >
        <v-icon> search </v-icon>
      </v-btn>
    </template>

    <template v-slot:content>
      <v-container
        grid-list-md
        fluid
        fill-height
      >
        <v-layout column>
          <v-flex
            class="my-2"
            overflow-hidden
          >
            <v-tabs
              right
              class="body-1 fill-height elevation-3 status-tree-view"
              grow
            >
              <v-tab>{{ $t("status.city") }}</v-tab>
              <v-tab-item>
                <v-treeview
                  :items="players"
                  class="status-tree-view"
                  open-on-click
                  :search="search"
                  color="grey"
                  hoverable
                  :activatable="true"
                  return-object
                  @update:active="itemSelected"
                />
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../Common/StandardContainer";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector";

export default {
  components: {
    standardContainer,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      players: [],
      showSearch: false,
      playerConnect: [],
      search: "",
    };
  },
  created() {
    this.getAllCitiesPlayers();
  },
  methods: {
    getAllCitiesPlayers() {
      this.playerConnector
        .getAllPlayersCities()
        .then((response) => {
          this.players = response;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    goToStatus() {
      this.$router.push({ path: "/status" });
    },
    itemSelected(item) {
      this.$emit("itemSelected", item);
    },
  },
};
</script>

<style>
.status-tree-view > .v-tabs-items {
  max-height: calc(100% - 48px);
  overflow: auto;
}
</style>
